import {createElement, Component, PropTypes} from 'rlink-react';

export default class ScrollTo extends Component {
  componentDidMount () {
    this.scrollTo();
  }
  componentDidUpdate (prevProps) {
    if (this.props.top !== prevProps.top
        || this.props.left !== prevProps.left) {
      this.scrollTo();
    }
  }
  scrollTo () {
    window.scrollTo(this.props.left, this.props.top);
  }
  render () {
    return null;
  }
}

ScrollTo.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
};

ScrollTo.defaultProps = {
  top: 0,
  left: 0,
};



// WEBPACK FOOTER //
// ./lib/rlink-scrolling/ScrollTo.jsx